/* BentoBliss – Product page v2 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }

  function addToCart(items) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) throw data;
        return data;
      });
    });
  }

  /* Hand the added item to the theme's existing cart drawer (Archetype pubsub event) */
  function announceAdded(data, button) {
    var cartType = (window.theme && theme.settings && theme.settings.cartType) || 'dropdown';
    if (cartType === 'page') {
      window.location.href = ROOT + 'cart';
      return;
    }
    var product = data && data.items ? data.items[0] : data;
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: product, addToCartBtn: button } }));
  }

  function errorText(err) {
    return (err && (err.description || err.message)) || 'Sorry, something went wrong. Please try again.';
  }

  /* ============================== MAIN PRODUCT ============================== */
  class BBProduct extends HTMLElement {
    connectedCallback() {
      this.money = this.dataset.moneyFormat;
      this.engravePrice = parseInt(this.dataset.engravingPrice || '0', 10);
      this.form = this.querySelector('[data-bbp-form]');
      this.idInput = this.querySelector('[data-variant-id]');
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.atc = this.querySelector('[data-atc]');
      this.atcLabel = this.querySelector('[data-atc-label]');
      var variantsEl = this.querySelector('[data-variants]');
      this.variants = variantsEl ? JSON.parse(variantsEl.textContent) : null;
      this.currentVariant = this.variants
        ? this.variants.find(function (v) { return String(v.id) === String(this.idInput && this.idInput.value); }, this) || this.variants[0]
        : null;
      this.price = this.currentVariant ? this.currentVariant.price : parseInt(this.dataset.price || '0', 10);
      this.available = this.atc ? !this.atc.disabled : true;

      this.initGallery();
      this.initOptions();
      this.initQty();
      this.initEngraving();
      this.initForm();
      this.initSticky();
      this.initSiblings();
      this.initReviewLink();
    }

    /* ---------- Gallery ---------- */
    initGallery() {
      var g = this.querySelector('[data-gallery]');
      if (!g) return;
      this.track = g.querySelector('[data-track]');
      this.slides = Array.prototype.slice.call(g.querySelectorAll('[data-slide]'));
      this.thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-thumb]'));
      this.counter = g.querySelector('[data-counter]');
      var self = this;
      var prev = g.querySelector('[data-prev]');
      var next = g.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { self.goTo(self.index() - 1); });
      if (next) next.addEventListener('click', function () { self.goTo(self.index() + 1); });
      this.thumbs.forEach(function (t) {
        t.addEventListener('click', function () { self.goTo(parseInt(t.dataset.thumb, 10)); });
      });
      var ticking = false;
      this.track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { self.syncGallery(); ticking = false; });
      }, { passive: true });
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') self.goTo(self.index() - 1);
        if (e.key === 'ArrowRight') self.goTo(self.index() + 1);
      });
    }
    index() {
      if (!this.track) return 0;
      return Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
    }
    goTo(i) {
      if (!this.track || !this.slides.length) return;
      var n = this.slides.length;
      i = (i + n) % n;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
    }
    syncGallery() {
      var i = this.index();
      if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.slides.length;
      this.thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      var active = this.thumbs[i];
      if (active && active.parentNode) {
        var p = active.parentNode;
        var left = active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    goToMedia(mediaId) {
      if (!mediaId || !this.slides) return;
      var idx = this.slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (idx > -1) this.goTo(idx);
    }

    /* ---------- Variants ---------- */
    initOptions() {
      var wrap = this.querySelector('[data-options]');
      if (!wrap || !this.variants) return;
      this.optionSets = Array.prototype.slice.call(wrap.querySelectorAll('[data-option-index]'));
      var self = this;
      wrap.addEventListener('change', function () { self.onOptionChange(); });
      this.markAvailability();
    }
    selectedOptions() {
      return this.optionSets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    onOptionChange() {
      var opts = this.selectedOptions();
      this.optionSets.forEach(function (fs, i) {
        var label = fs.querySelector('[data-option-value]');
        if (label) label.textContent = opts[i];
      });
      var variant = this.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      this.setVariant(variant);
      this.markAvailability();
    }
    markAvailability() {
      if (!this.optionSets || this.optionSets.length !== 1) return;
      var self = this;
      this.optionSets[0].querySelectorAll('input').forEach(function (input) {
        var v = self.variants.find(function (x) { return x.options[0] === input.value; });
        input.closest('.bbp-pill').classList.toggle('is-unavailable', !v || !v.available);
      });
    }
    setVariant(variant) {
      this.currentVariant = variant || null;
      if (!variant) {
        this.available = false;
        this.updateButton('Unavailable');
        return;
      }
      this.idInput.value = variant.id;
      this.price = variant.price;
      this.available = variant.available;

      var price = this.querySelector('[data-price]');
      var compare = this.querySelector('[data-compare]');
      var save = this.querySelector('[data-save]');
      var badge = this.querySelector('[data-sale-badge]');
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (price) { price.textContent = formatMoney(variant.price, this.money); price.classList.toggle('is-sale', !!onSale); }
      if (compare) { compare.hidden = !onSale; if (onSale) compare.textContent = formatMoney(variant.compare_at_price, this.money); }
      if (save) { save.hidden = !onSale; if (onSale) save.textContent = 'Save ' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%'; }
      if (badge) badge.hidden = !onSale;

      var stock = this.querySelector('[data-stock-text]');
      if (stock) stock.textContent = variant.available ? stock.dataset.inStock : stock.dataset.soldOut;

      if (variant.featured_media) this.goToMedia(variant.featured_media.id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      this.updateButton();
      this.dispatchEvent(new CustomEvent('bbp:variant', { bubbles: true, detail: { variant: variant } }));
    }

    /* ---------- Quantity ---------- */
    initQty() {
      var self = this;
      this.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(self.qtyInput.value, 10) || 1) + parseInt(b.dataset.qty, 10));
          self.qtyInput.value = v;
          self.updateButton();
        });
      });
      if (this.qtyInput) this.qtyInput.addEventListener('input', function () { self.updateButton(); });
    }
    qty() { return Math.max(1, parseInt(this.qtyInput && this.qtyInput.value, 10) || 1); }

    updateButton(forceLabel) {
      if (!this.atc) return;
      var sticky = this.querySelector('[data-sticky-btn]');
      var stickyPrice = this.querySelector('[data-sticky-price]');
      if (forceLabel || !this.available) {
        var label = forceLabel || 'Sold out';
        this.atc.disabled = true;
        this.atcLabel.textContent = label;
        if (sticky) { sticky.disabled = true; sticky.textContent = label; }
        return;
      }
      var unit = this.price + (this.engraveOn() ? this.engravePrice : 0);
      var total = formatMoney(unit * this.qty(), this.money);
      this.atc.disabled = false;
      this.atcLabel.textContent = 'Add to cart · ' + total;
      if (sticky) { sticky.disabled = false; sticky.textContent = 'Add to cart'; }
      if (stickyPrice) stickyPrice.textContent = formatMoney(unit, this.money);
    }

    /* ---------- Engraving (same cart properties as the current live page) ---------- */
    initEngraving() {
      this.engrave = this.querySelector('[data-engrave]');
      if (!this.engrave) return;
      this.engraveToggle = this.engrave.querySelector('[data-engrave-toggle]');
      this.engraveFields = this.engrave.querySelector('[data-engrave-fields]');
      this.engraveText = this.engrave.querySelector('[data-engrave-text]');
      this.engraveCount = this.engrave.querySelector('[data-engrave-count]');
      this.engraveError = this.engrave.querySelector('[data-engrave-error]');
      this.engraveVariant = this.querySelector('[data-engrave-variant]');
      var self = this;
      this.engraveToggle.addEventListener('change', function () {
        self.engraveFields.hidden = !self.engraveToggle.checked;
        self.engraveError.hidden = true;
        if (self.engraveToggle.checked && self.engraveText) self.engraveText.focus();
        self.updateButton();
      });
      if (this.engraveText) {
        this.engraveText.addEventListener('input', function () {
          self.engraveCount.textContent = self.engraveText.value.length + '/15';
          self.engraveError.hidden = true;
        });
      }
      this.engrave.addEventListener('change', function (e) {
        if (e.target.matches('[data-engrave-place]')) self.engraveError.hidden = true;
      });
    }
    engraveOn() { return !!(this.engraveToggle && this.engraveToggle.checked); }
    engraveProperties(showErrors) {
      if (!this.engrave) return {};
      if (!this.engraveOn()) return { 'Personalised Bottle?:': 'No' };
      var text = (this.engraveText && this.engraveText.value.trim()) || '';
      var placeInputs = this.engrave.querySelectorAll('[data-engrave-place]');
      var place = this.engrave.querySelector('[data-engrave-place]:checked');
      var msg = '';
      if (!text) msg = 'Please enter the name you’d like engraved.';
      else if (placeInputs.length && !place) msg = 'Please choose a text placement.';
      if (msg) {
        if (showErrors) {
          this.engraveError.textContent = msg;
          this.engraveError.hidden = false;
          this.engrave.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return null;
      }
      var props = { 'Engraving Text': text };
      if (place) props['Text Placement'] = place.value;
      return props;
    }

    /* Line items for the main product (+ engraving add-on). Used by the form and by FBT. */
    buildMainItems(quantity, showErrors) {
      var props = this.engraveProperties(showErrors);
      if (props === null) return null;
      var items = [{ id: parseInt(this.idInput.value, 10), quantity: quantity, properties: props }];
      if (this.engraveOn() && this.engraveVariant) {
        items.push({ id: parseInt(this.engraveVariant.value, 10), quantity: quantity });
      }
      return items;
    }

    /* ---------- Form ---------- */
    initForm() {
      if (!this.form) return;
      var self = this;
      this.formError = this.querySelector('[data-form-error]');
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        self.submit(self.atc);
      });
    }
    submit(button) {
      if (!this.available) return;
      var items = this.buildMainItems(this.qty(), true);
      if (!items) return;
      var self = this;
      this.formError.hidden = true;
      this.atc.classList.add('is-loading');
      addToCart(items)
        .then(function (data) { announceAdded(data, button || self.atc); })
        .catch(function (err) {
          self.formError.textContent = errorText(err);
          self.formError.hidden = false;
        })
        .finally(function () { self.atc.classList.remove('is-loading'); });
    }

    /* ---------- Sticky ATC (mobile) ---------- */
    initSticky() {
      var sticky = this.querySelector('[data-sticky]');
      if (!sticky || !this.atc || !('IntersectionObserver' in window)) return;
      var self = this;
      var btn = sticky.querySelector('[data-sticky-btn]');
      btn.addEventListener('click', function () {
        if (self.engrave && self.engraveOn() && self.engraveProperties(false) === null) {
          self.atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
          self.engraveProperties(true);
          return;
        }
        self.submit(btn);
      });
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        btn.tabIndex = show ? 0 : -1;
      });
      io.observe(this.atc);
    }

    /* ---------- Sibling colours (separate products named "Name - Colour") ---------- */
    initSiblings() {
      var wrap = this.querySelector('[data-siblings-wrap]');
      if (!wrap) return;
      var base = wrap.dataset.baseTitle;
      var list = wrap.querySelector('[data-sibling-list]');
      var handleOf = function (u) { return String(u || '').split('?')[0].split('#')[0].replace(/\/$/, '').split('/').pop(); };
      var current = handleOf(this.dataset.productUrl || location.pathname);
      var prefix = (base + ' - ').toLowerCase();
      var q = encodeURIComponent('"' + base + '"');

      var render = function (products) {
        var seen = {};
        seen[current] = true;
        products.forEach(function (p) {
          var h = handleOf(p.url);
          if (!p.title || p.title.toLowerCase().indexOf(prefix) !== 0 || seen[h]) return;
          seen[h] = true;
          var a = document.createElement('a');
          a.className = 'bbp-pill bbp-pill--img';
          a.href = p.url.split('?')[0];
          var soldOut = p.available === false;
          if (soldOut) {
            // Sold-out colour: greyed, dashed, struck through (still clickable)
            a.classList.add('is-unavailable');
            a.title = 'Sold out';
            a.style.background = '#f4f1ec';
            a.style.borderStyle = 'dashed';
            a.style.color = '#9b968d';
          }
          if (p.image) {
            var img = document.createElement('img');
            img.src = p.image + (p.image.indexOf('width=') > -1 ? '' : (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=80');
            img.alt = '';
            img.loading = 'lazy';
            if (soldOut) { img.style.opacity = '.45'; img.style.filter = 'grayscale(1)'; }
            a.appendChild(img);
          }
          var name = p.title.slice(prefix.length);
          if (soldOut) {
            var s = document.createElement('s');
            s.textContent = name;
            a.appendChild(s);
          } else {
            a.appendChild(document.createTextNode(name));
          }
          list.appendChild(a);
        });
      };

      // Fallback: predictive search (max 10 results)
      var suggest = function () {
        return fetch(ROOT + 'search/suggest.json?q=' + q +
          '&resources[type]=product&resources[limit]=10&resources[options][fields]=title&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            render((data.resources && data.resources.results && data.resources.results.products) || []);
          });
      };

      // Primary: full store search via Section Rendering (up to 50 results, includes sold-out colours)
      fetch(ROOT + 'search?q=' + q + '&type=product&options[unavailable_products]=last&section_id=bb-sibling-search')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-bb-sibling-data]');
          if (!el) throw new Error('no data');
          render(JSON.parse(el.textContent));
        })
        .catch(function () { return suggest(); })
        .catch(function () {});
    }

    initReviewLink() {
      var link = this.querySelector('[data-scroll-reviews]');
      if (!link) return;
      link.addEventListener('click', function (e) {
        var target = document.getElementById('bb-reviews') || document.querySelector('.jdgm-rev-widg');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }
  if (!customElements.get('bb-product')) customElements.define('bb-product', BBProduct);

  /* ============================== FREQUENTLY BOUGHT TOGETHER ============================== */
  class BBFbt extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('bb-product');
      this.list = this.querySelector('[data-fbt-list]');
      this.main = this.querySelector('[data-fbt-main]');
      this.totalEl = this.querySelector('[data-fbt-total]');
      this.countEl = this.querySelector('[data-fbt-count-label]');
      this.btn = this.querySelector('[data-fbt-add]');
      this.err = this.querySelector('[data-fbt-error]');
      this.money = this.product ? this.product.dataset.moneyFormat : null;
      this.extras = [];
      var self = this;

      this.list.addEventListener('change', function () { self.render(); });
      this.btn.addEventListener('click', function () { self.addAll(); });
      if (this.product) {
        this.product.addEventListener('bbp:variant', function (e) {
          var v = e.detail.variant;
          self.querySelector('[data-fbt-main-price]').textContent = formatMoney(v.price, self.money);
          self.querySelector('[data-fbt-main-variant]').textContent = v.title;
          self.render();
        });
      }
      this.load();
    }
    fetchRecs(intent) {
      var url = this.dataset.url + '?product_id=' + this.dataset.productId + '&limit=' + (parseInt(this.dataset.limit, 10) + 3) + '&intent=' + intent;
      return fetch(url).then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (d) { return d.products || []; }).catch(function () { return []; });
    }
    load() {
      var self = this;
      var limit = parseInt(this.dataset.limit, 10) || 3;
      this.fetchRecs('complementary').then(function (list) {
        return list.length ? list : self.fetchRecs('related');
      }).then(function (list) {
        var pid = String(self.dataset.productId);
        var recEl = document.querySelector('bb-recommendations');
        var exH = ((recEl && recEl.dataset.excludeHandles) || 'personalised-engraving,shipping-protection').toLowerCase().split(',');
        var exT = ((recEl && recEl.dataset.excludeTypes) || 'personalisation,ship_protect').toLowerCase().split(',').map(function (t) { return t.trim(); });
        list = list.filter(function (p) {
          if (exH.indexOf(String(p.handle).toLowerCase()) > -1) return false;
          if (p.type && exT.indexOf(String(p.type).toLowerCase().trim()) > -1) return false;
          return String(p.id) !== pid && p.available && p.variants && p.variants.some(function (v) { return v.available; });
        }).slice(0, limit);
        if (!list.length) return;
        list.forEach(function (p) { self.addCard(p); });
        self.hidden = false;
        self.render();
      });
    }
    addCard(p) {
      var v = p.variants.find(function (x) { return x.available; });
      var label = document.createElement('label');
      label.className = 'bbp-fbt__item is-checked';
      label.dataset.variantId = v.id;
      label.dataset.price = v.price;
      label.innerHTML =
        '<input type="checkbox" checked data-fbt-check>' +
        '<span class="bbp-fbt__box" aria-hidden="true"></span>' +
        '<span class="bbp-fbt__img"></span>' +
        '<span class="bbp-fbt__text"><strong></strong><span class="bbp-fbt__meta"></span></span>' +
        '<span class="bbp-fbt__price"></span>';
      var img = p.featured_image || (p.images && p.images[0]);
      if (img) {
        var el = document.createElement('img');
        el.src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        el.alt = '';
        el.loading = 'lazy';
        label.querySelector('.bbp-fbt__img').appendChild(el);
      }
      var link = document.createElement('a');
      link.href = p.url;
      link.textContent = p.title;
      link.style.color = 'inherit';
      link.style.textDecoration = 'none';
      link.addEventListener('click', function (e) { e.stopPropagation(); });
      label.querySelector('strong').appendChild(link);
      var meta = p.variants.length > 1 ? v.title : '';
      label.querySelector('.bbp-fbt__meta').textContent = meta;
      label.querySelector('.bbp-fbt__price').textContent = formatMoney(v.price, this.money);
      this.list.appendChild(label);
    }
    mainPrice() {
      var p = this.product;
      if (!p) return 0;
      return (p.price || 0) + (p.engraveOn && p.engraveOn() ? p.engravePrice : 0);
    }
    render() {
      var items = Array.prototype.slice.call(this.list.querySelectorAll('.bbp-fbt__item'));
      var total = 0;
      var count = 0;
      var self = this;
      items.forEach(function (item) {
        var checked = item.querySelector('[data-fbt-check]').checked;
        item.classList.toggle('is-checked', checked);
        if (!checked) return;
        count++;
        total += item === self.main ? self.mainPrice() : parseInt(item.dataset.price, 10);
      });
      this.totalEl.textContent = formatMoney(total, this.money);
      this.countEl.textContent = 'Total for ' + count + ' item' + (count === 1 ? '' : 's');
      this.btn.disabled = count === 0;
      this.btn.textContent = count <= 1 ? 'Add to cart' : 'Add all ' + count + ' to cart';
    }
    addAll() {
      var self = this;
      var items = [];
      var mainChecked = this.main.querySelector('[data-fbt-check]').checked;
      if (mainChecked && this.product) {
        var mainItems = this.product.buildMainItems(1, true);
        if (!mainItems) return;
        if (!this.product.available) mainItems = [];
        items = items.concat(mainItems);
      }
      this.list.querySelectorAll('.bbp-fbt__item').forEach(function (item) {
        if (item === self.main || !item.querySelector('[data-fbt-check]').checked) return;
        items.push({ id: parseInt(item.dataset.variantId, 10), quantity: 1 });
      });
      if (!items.length) return;
      this.err.hidden = true;
      this.btn.disabled = true;
      addToCart(items)
        .then(function (data) { announceAdded(data, self.btn); })
        .catch(function (e) { self.err.textContent = errorText(e); self.err.hidden = false; })
        .finally(function () { self.btn.disabled = false; });
    }
  }
  if (!customElements.get('bb-fbt')) customElements.define('bb-fbt', BBFbt);

  /* ============================== RECOMMENDATIONS ============================== */
  class BBRecommendations extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-quick-add]');
        if (!btn) return;
        e.preventDefault();
        btn.disabled = true;
        addToCart([{ id: parseInt(btn.dataset.quickAdd, 10), quantity: 1 }])
          .then(function (data) {
            btn.classList.add('is-added');
            announceAdded(data, btn);
          })
          .catch(function () {})
          .finally(function () { btn.disabled = false; });
      });
      if (this.querySelector('.bbp-card')) return;
      fetch(self.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('bb-recommendations');
          if (inner && inner.innerHTML.trim().length) self.innerHTML = inner.innerHTML;
        })
        .catch(function () {});
    }
  }
  if (!customElements.get('bb-recommendations')) customElements.define('bb-recommendations', BBRecommendations);
})();
